import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_SUPABASE_URL : process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_SUPABASE_ANON_KEY : process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase credentials');
}

// Remove quotes if they exist
const cleanUrl = supabaseUrl.replace(/['"]/g, '');
const cleanKey = supabaseAnonKey.replace(/['"]/g, '');

export const supabase = createClient(cleanUrl, cleanKey);

// Authentication helper functions
export const signIn = async ({ email, password }) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    return { data, error };
  } catch (err) {
    console.error('Sign in error:', err);
    return { error: err };
  }
};

// Authentification avec Google
/** Lance l'authentification Google et conserve une destination utile, telle qu'une invitation. */
export const signInWithGoogle = async ({ redirectTo } = {}) => {
  try {
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: redirectTo || `${window.location.origin}/app/dashboard`,
        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        },
      }
    });

    return { data, error };
  } catch (err) {
    console.error('Google sign in error:', err);
    return { error: err };
  }
};

/** Crée le compte et, lorsque nécessaire, renvoie la confirmation vers une invitation à accepter. */
export const signUp = async ({ email, password, fullName, emailRedirectTo }) => {
  try {
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo,
        data: {
          // Stocke le nom dans les métadonnées de l'utilisateur, disponibles après la confirmation de l'e-mail.
          full_name: fullName,
        },
      },
    });

    if (authError) return { error: authError };

    // if (authData?.user) {
    //   const { error: profileError } = await supabase
    //     .from('profiles')
    //     .insert([{ id: authData.user.id, email, full_name: fullName }]);
    //   console.log('Profile creation response:', { profileError });
    //   if (profileError) return { error: profileError };
    // }

    return { data: authData };
  } catch (err) {
    console.error('Sign up error:', err);
    return { error: err };
  }
};

export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut();
  
    return { error };
  } catch (err) {
    console.error('Sign out error:', err);
    return { error: err };
  }
};

export const getCurrentUser = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();

    return { user, error };
  } catch (err) {
    console.error('Get current user error:', err);
    return { error: err };
  }
};

export const getProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
 
    return { data, error };
  } catch (err) {
    console.error('Get profile error:', err);
    return { error: err };
  }
};

// Renvoyer l'email de confirmation
export const resendConfirmationEmail = async (email) => {
  try {
    const { data, error } = await supabase.auth.resend({
      type: 'signup',
      email: email,
    });
    
    if (error) throw error;
    return { data };
  } catch (err) {
    console.error('Error resending confirmation email:', err);
    return { error: err };
  }
};

// Récupérer les paramètres Shopify de l'utilisateur
export const getShopifySettings = async () => {
  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError) throw userError;

    const { data, error } = await supabase
      .from('settings')
      .select('*')
      .eq('user_id', user.id)
      .eq('type', 'shopify')
      .single();

    return { data, error };
  } catch (err) {
    console.error('Erreur lors de la récupération des paramètres Shopify:', err);
    return { error: err };
  }
};
